module.exports = __webpack_public_path__ + "img/04.2fe03802.gif";